
import { validate } from './libs/regular'
const components = [
]

const install = function (Vue) {
  if (install.installed) return
  components.forEach(component => Vue.component(component.name, component))
  Vue.prototype.validate = validate
  // Vue.prototype.$Message = Message
  // Vue.prototype.$Modal = Modal
}

export default {
  install,
  ...components
}



// WEBPACK FOOTER //
// ./libs/index.js